var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y88pkcrcya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45 16.126V6.088c0-.717.58-1.297 1.3-1.297h1.539a2.7 2.7 0 0 0 1.921-.803l1.013-1.026a1.3 1.3 0 0 1 .925-.387h2.704c.347 0 .68.14.925.387l1.013 1.026a2.7 2.7 0 0 0 1.921.803h1.539a1.3 1.3 0 0 1 1.3 1.3v10.034a1.3 1.3 0 0 1-1.3 1.3H3.75a1.3 1.3 0 0 1-1.3-1.3z",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.938,
    r: 3.05,
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.708,
    cy: 7.333,
    r: 0.833,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "y88pkcrcya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/camera_white.1b0de77ffa5bf058b3de77ff74d5d43a.svg";
export { ForwardRef as ReactComponent };